import(/* webpackMode: "eager" */ "/github/workspace/stripepayment/app/page.tsx")